import React, { useState, useEffect } from "react";
import EnergyOffers from "./components/Tabs/OfferTab";
import SignupTabs from "./components/ContractTabs/SignupTabs";
import GreenmanEnergyForm from "./components/Tabs/NumeratorTab";
import OrderConfirmation from "./components/ContractTabs/successScreen";
// import "./i18n/i18n"; // import the i18n config
import { initialValues } from "./validations/initialValues";
import i18n from "./i18n/i18n";

function App() {
  const [step, setStep] = useState(0);
  const [values, setValues] = useState({});
  const [formData, setFormData] = useState(initialValues);
  const queryParams = new URLSearchParams(window.location.search);
  const paramValue = queryParams.get("lang");
  useEffect(() => {
    if (paramValue) {
      // setSavedLanguage(paramValue);
      i18n.changeLanguage(paramValue);
      localStorage.setItem("language", paramValue);
    }
    localStorage.removeItem("customer_id");
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);
  const renderStepContent = () => {
    switch (step) {
      case 0:
        return (
          <GreenmanEnergyForm
            setStep={setStep}
            formValues={values}
            setValues={setValues}
            setFormData={setFormData}
            step={step}
          />
        );
      case 1:
        return (
          <EnergyOffers
            setStep={setStep}
            values={values}
            formData={formData}
            setFormData={setFormData}
          />
        );
      case 2:
        return (
          <SignupTabs
            setStep={setStep}
            values={values}
            formData={formData}
            setFormData={setFormData}
          />
        );
      case 3:
        return (
          <OrderConfirmation
            setStep={setStep}
            setValues={setValues}
            values={values}
            formData={formData}
            setFormData={setFormData}
          />
        );
      default:
        return null;
    }
  };
  return <div>{renderStepContent()}</div>;
}

export default App;
